"use strict";

/******************************************************
 *    Directive pour afficher les informations d'un élève
 ********************************************************/

angular.module("app").directive("okinaBackButton", ["$window", function ($window) {
	return {
		restrict: "E",
		templateUrl: "common/directives/okinaBackButton/okinaBackButton.html",
		replace: false,
		link: function (scope, elt, attrs) {
			elt.on("click", function () {
				$window.history.back();
				setTimeout(
					function () {
						if (window.location.href.indexOf("/new") !== -1) {
							$window.history.back();
						}
					}, 1000);
			});
		}
	};
}])
;
